import { Box, Alert, Card, Container, Grid } from '@mui/material';
import React, { Component } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Helmet } from 'react-helmet';
import CashlessResults from './CashlessResults';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import CashlessToolbar from './CashlessToolbar';
import moment from 'moment';
import { filter } from 'lodash';
import Fab from '@mui/material/Fab';
import DoneAll from '@mui/icons-material/DoneAll';
import CashlessActionDialog from './CashlessActionDialog';
import { BulkActionContent } from './CashlessActionDialog';
import { corpNameMapper } from './CashlesInfoText';
import csvDownload from 'json-to-csv-export';

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
export class CashlessMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalCount: 0,
      dateRange: [],
      displayRequests: [],
      filteredRequests: [],
      allRequests: [],
      actionableRequests: [],
      actionedRequests: [],
      actionDialogOpened: false,
      actionDialogContent: {},
      actionDialogTitle: null,
      isActionRejection: false,
      selectedRequests: {},
      selectedRequestIdList: [],
      searchResultReqs: [],
      singleSelectRequest: null,
      searchedOrderId: null,
      selectionData: {
        corpName: []
      },
      selectAll: false,
      filter: {
        dateRange: [],
        corpName: [],
        actionableStatus: []
      },
      filterOptions: {
        corpNameList: [],
        actionableStatusList: []
      },
      loading: {
        cashlessRequests: false
      },
      server: {},
      totalRequestCount: 0,
      activeTable: 1,
      startIndex: 0,
      pageSize: 5,
      numberOfSelectedRequests: 0,
      totalAmountOfSelectedRequests: 0,
      totalNumberOfSelectedCorporates: 0,
      uniqueSelectedContracts: [],
      resultsLimit: 5,
      resultsPage: 0
    };
  }

  setLoadingServer(name, loading, server) {
    this.setState((prev) => ({
      loading: {
        ...prev.loading,
        [name]: loading
      },
      server: {
        ...prev.server,
        [name]: server
      }
    }));
  }

  setFilters(obj) {
    this.setState(
      {
        filter: {
          ...obj,
          campus: [],
          location: [],
          bene: []
        }
      },
      () => {
        this.applyFilters();
      }
    );
  }

  resetFilters() {
    this.setState({
      filter: {
        dateRange: [],
        campus: [],
        location: [],
        bene: []
      }
    });
  }

  setActiveTable(tab) {
    if (tab == this.state.activeTable) {
      return;
    }
    this.setState(
      {
        activeTable: tab,
        displayRequests: [],
        startIndex: 0,
        pageSize: 5
      },
      () => {
        this.fetchCashlessRequests();
      }
    );
  }

  filterResults(query, req_list) {
    if (query) {
      const req_list_new = req_list.filter((ele) => {
        if (ele.orderid.toString().startsWith(query.toString())) {
          return true;
        } else {
          return false;
        }
      });
      //console.log(req_list_new);
      return req_list_new;
    } else {
      return req_list;
    }
  }
  
  downloadResults() {
    let json_data =  this.state.allRequests;
    json_data = json_data.map((ele) => {
      return {
        "Orderid" : ele.orderid,
        "Service Name":ele.service_type,
        "Cart Items":ele.cart_items,
        "Patient Name":ele.name,
        "Email":ele.email,
        "Phone Number":ele.phonenumber,
        "Order Created Date":ele.createdon,
        "Fulfilled Date":ele.fullfilledon,
        "Corporate Name":ele.corporate_name,
        "Age":ele.age,
        "Gender":ele.gender,
        "Relation":ele.relation,
        "Total Cashless Amount":ele.total_cashless_amount,
        "Total PG amount":ele.total_pg_amount,
        "Total_amount":ele.total_amount,
        "Status":ele.status,
        "Requestid":ele.requestid,
        "Remark":ele.remark
      }
    })
    if (json_data.length > 0) {
      const data_to_download = {
        data: json_data,
        filename: 'claims_data',
        delimiter: ',',
        headers: Object.keys(json_data[0])
      };
      csvDownload(data_to_download);
    }
  }
  toolBarDateRange = [];
  toolBarCorporateList = null;
  toolBarServiceList = null;

  onFilterChange(type, value, activeTable) {
    let obj = {};
    let start = 0;
    let end = 0;
    let new_list = [];
    let req_list =
      this.state.activeTable == 1
        ? this.state.actionableRequests
        : this.state.actionedRequests;

    if (this.state.searchedOrderId) {
      req_list = this.state.searchResultReqs;
    }

    switch (type) {
      case 'limit':
        obj.pageSize = value;
        start = value * 0;
        end = start + value;
        new_list = req_list.slice(start, end);
        this.setState({
          pageSize: value,
          startIndex: 0,
          displayRequests: new_list
        });
        break;
      case 'page':
        obj.startIndex = value;
        start = value * this.state.pageSize;
        end = start + this.state.pageSize;
        new_list = req_list.slice(start, end);
        this.setState({
          startIndex: value,
          displayRequests: new_list
        });
        break;
    }
  }

  fetchCashlessRequests(obj = {}) {
    let payLoad = {};

    payLoad.startDate = (
      this.toolBarDateRange[0]
        ? moment(this.toolBarDateRange[0])
        : moment().startOf('year')
    ).format('YYYY-MM-DD');
    payLoad.endDate = (
      this.toolBarDateRange[1] ? moment(this.toolBarDateRange[1]) : moment()
    )
      .add(1, 'days')
      .format('YYYY-MM-DD');

    if (this.toolBarCorporateList && this.toolBarServiceList) {
      const selectedCorps = Object.keys(this.toolBarCorporateList).filter(
        (ele) => this.toolBarCorporateList[ele]
      );

      const selectedServices = Object.keys(this.toolBarServiceList).filter(
        (ele) => this.toolBarServiceList[ele]
      );

      payLoad.corpList = selectedCorps
        .map((ele) => corpNameMapper(ele))
        .join(',');
      payLoad.serviceList = selectedServices.join(',');
    }

    //console.log(payLoad);
    this.setLoadingServer('cashlessRequests', true, true);
    _axios
      .get('cashless', {
        params: payLoad
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          const start = 0;
          const end = start + this.state.pageSize;
          const actionables = response.data.result.filter(
            (ele) => ele.status && ele.status == 'yet to be actioned'
          );
          const actioned = response.data.result.filter(
            (ele) => ele.status && ele.status != 'yet to be actioned'
          );
          let filteredRequests =
            this.state.activeTable == 1 ? actionables : actioned;

          if (this.state.searchedOrderId) {
            filteredRequests = this.filterResults(
              this.state.searchedOrderId,
              filteredRequests
            );
          }

          let displayRequests = filteredRequests.slice(start, end);
          let selectedRequestDict = {};
          filteredRequests.forEach((ele) => {
            if (ele.requestid) {
              selectedRequestDict[ele.requestid.toString()] = false;
            }
          });
          this.setState(
            {
              allRequests: response.data.result,
              actionableRequests: actionables,
              actionedRequests: actioned,
              displayRequests: displayRequests,
              totalRequestCount: filteredRequests.length,
              selectedRequests: selectedRequestDict,
              searchResultReqs: filteredRequests,
              selectAll: false
            },
            () => this.setLoadingServer('cashlessRequests', false, true)
          );
          console.log(displayRequests)
        } else {
          this.setLoadingServer('cashlessRequests', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('cashlessRequests', false, false);
      });
  }

  setSelectedRequests(selectionDictionary) {
    let selectedRequestIds = Object.keys(selectionDictionary).filter((ele) => {
      if (selectionDictionary[ele]) {
        return true;
      }
    });

    /* let filteredSelectedRequestIds = null; */

    if (this.state.searchedOrderId) {
      const searchResultRequestIds = this.state.searchResultReqs.map(
        (ele) => ele.requestid
      );
      selectedRequestIds = selectedRequestIds.filter((ele) => {
        if (searchResultRequestIds.includes(ele)) {
          return true;
        } else {
          return false;
        }
      });

      Object.keys(selectionDictionary).forEach((ele) => {
        if (!searchResultRequestIds.includes(ele)) {
          selectionDictionary[ele] = false;
        }
      });
    }

    const allRequestIds = this.state.allRequests.map((ele) =>
      ele.requestid.toString()
    );
    let selectedRequestIdIndices = selectedRequestIds.map((ele) =>
      allRequestIds.indexOf(ele)
    );
    selectedRequestIdIndices = selectedRequestIdIndices.filter(
      (ele) => ele >= 0
    );

    const selectedCorporates = selectedRequestIdIndices
      .map((ele) => {
        return this.state.allRequests[ele].corporate_name;
      })
      .filter(onlyUnique);
    const selectedServices = selectedRequestIdIndices
      .map((ele) => {
        return this.state.allRequests[ele].service_type;
      })
      .filter(onlyUnique);

    const selectedAmount = selectedRequestIdIndices.reduce((sum, ele) => {
      return sum + this.state.allRequests[ele].total_cashless_amount;
    }, 0);

    this.setState({
      selectedRequests: selectionDictionary,
      numberOfSelectedRequests: selectedRequestIds.length,
      totalAmountOfSelectedRequests: selectedAmount,
      uniqueSelectedContracts: selectedServices,
      totalNumberOfSelectedCorporates: selectedCorporates.length,
      selectedRequestIdList: selectedRequestIds
    });
  }

  setSelectAllState(val) {
    this.setState({
      selectAll: val
    });
  }

  applyFilters() {
    const payload = {};
    if (this.state.filter.campus.length)
      payload.provider = this.state.filter.campus;
    if (this.state.filter.location.length)
      payload.cityId = this.state.filter.location;
    if (this.state.filter.bene.length && this.state.activeTable == 1)
      payload.benf = this.state.filter.bene;
    if (this.state.filter.dateRange.length == 2) {
      payload['apptDateBegin'] = moment(this.state.filter.dateRange[0]).format(
        'YYYY-MM-DD'
      );
      payload['apptDateEnd'] = moment(this.state.filter.dateRange[1])
        .add(1, 'days')
        .format('YYYY-MM-DD');
    }
    this.fetchCashlessRequests(payload);
  }

  handleCashlessActionDialogCloseClicked(ignore_refetch) {
    this.setState({
      actionDialogOpened: false
    });
    if (!ignore_refetch && ignore_refetch == false) {
      this.fetchCashlessRequests();
    }
  }

  handleCashlessActionDialogOpenClicked(content, title, isRejection) {
    this.setState({
      actionDialogOpened: true,
      actionDialogContent: content,
      actionDialogTitle: title,
      isActionRejection: isRejection
    });
  }

  setResultsPage(page) {
    this.setState({
      resultsPage: page
    });
  }

  setResultsLimit(limit) {
    this.setState({
      resultsLimit: limit
    });
  }

  setSearchedOrderId(orderId) {
    const currentRequestList =
      this.state.activeTable == 1
        ? this.state.actionableRequests
        : this.state.actionedRequests;
    const filteredRequestList = this.filterResults(orderId, currentRequestList);
    const currentPage = 0;
    const constCurrentPageSize = this.state.pageSize;

    const start = currentPage * constCurrentPageSize;
    const end = start + constCurrentPageSize;

    const new_list = filteredRequestList.slice(start, end);

    /* let selectedRequestDict = {};
    Object.keys(this.state.selectedRequests).forEach((ele) => {
      if (ele.requestid) {
        selectedRequestDict[ele.requestid.toString()] = false;
      }
    });
 */
    this.setState({
      searchedOrderId: orderId,
      startIndex: 0,
      displayRequests: new_list,
      searchResultReqs: filteredRequestList,
      totalRequestCount: filteredRequestList.length,
      // selectedRequests: selectedRequestDict,
      resultsPage: 0
      //resultsLimit: 5
    });
  }

  componentDidMount() {
    this.fetchCashlessRequests();
  }
  render() {
    return (
      <>
        <Helmet>
          <title>Cashless | Utilization</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          {' '}
          <Grid
            item
            sx={{
              marginLeft: 3
            }}
          >
            <CashlessToolbar
              setFilters={(e) => this.setFilters(e)}
              refButtonAction={() => {
                this.fetchCashlessRequests();
              }}
              setToolBarOptions={(dateRange, corpList, serviceList) => {
                this.toolBarDateRange = dateRange;
                this.toolBarCorporateList = corpList;
                this.toolBarServiceList = serviceList;
              }}
              setSearchOptions={(orderId) => {
                this.setSearchedOrderId(orderId);
              }}
            />
          </Grid>
          <Container maxWidth={false}>
            <Grid container>
              <Grid item xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 2,
                    p: 3,
                    boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                  }}
                >
                  <CashlessResults
                    displayRequests={this.state.displayRequests}
                    totalRequestCount={this.state.totalRequestCount}
                    selectedRequests={this.state.selectedRequests}
                    setRequestSelection={(sel) => this.setSelectedRequests(sel)}
                    setSingleRequest={(val) => {
                      this.setState({
                        singleSelectRequest: val
                      });
                    }}
                    selectAll={this.state.selectAll}
                    setSelectAll={(val) => {
                      this.setSelectAllState(val);
                    }}
                    setActiveTable={(e) => this.setActiveTable(e)}
                    activeTable={this.state.activeTable}
                    actionDialogOpened={this.state.actionDialogOpened}
                    actionDialogOpenHandler={(
                      content,
                      title,
                      isRejection,
                      requestids
                    ) => {
                      this.handleCashlessActionDialogOpenClicked(
                        content,
                        title,
                        isRejection
                      );
                    }}
                    loading={this.state.loading}
                    server={this.state.server}
                    exportFile={(filetype) => this.exportFile(filetype)}
                    onPaginationChange={(type, value, activeTable) =>
                      this.onFilterChange(type, value, activeTable)
                    }
                    searchedOrderId={this.state.searchedOrderId}
                    page={this.state.resultsPage}
                    limit={this.state.resultsLimit}
                    setPage={(page) => {
                      this.setResultsPage(page);
                    }}
                    setLimit={(limit) => {
                      this.setResultsLimit(limit);
                    }}
                    downloadResults={() => {this.downloadResults()}}
                  />
                </Card>
              </Grid>
            </Grid>
          </Container>
          <Snackbar
            open={this.state.showSnack}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={4000}
            onClose={() => this.setState({ showSnack: false })}
          >
            <Alert
              onClose={() => this.setState({ showSnack: false })}
              severity={this.state.snackType}
            >
              {this.state.snackMsg}
            </Alert>
          </Snackbar>
        </Box>
        {Object.keys(this.state.selectedRequests).filter((key) => {
          if (this.state.selectedRequests[key] == true) {
            return true;
          }
          return false;
        }).length ? (
          <Fab
            variant="extended"
            color={this.state.actionDialogOpened ? 'success' : 'secondary'}
            style={{
              margin: 0,
              top: 'auto',
              right: 50,
              bottom: 120,
              left: 'auto',
              position: 'fixed'
            }}
            onClick={(e) => {
              this.handleCashlessActionDialogOpenClicked(
                <BulkActionContent
                  AggregateDetails={{
                    num_requests: this.state.numberOfSelectedRequests,
                    total_cashless: this.state.totalAmountOfSelectedRequests,
                    total_number_of_corporates:
                      this.state.totalNumberOfSelectedCorporates,
                    unique_services: this.state.uniqueSelectedContracts
                  }}
                />,
                'Confirm Bulk Approval Of Claims',
                false
              );
            }}
          >
            <DoneAll sx={{ mr: 1 }} />
            {'Bulk Approve (' +
              this.state.numberOfSelectedRequests +
              (this.state.numberOfSelectedRequests > 1
                ? ' Claims)'
                : ' Claim)')}
          </Fab>
        ) : null}
        <CashlessActionDialog
          openStatus={this.state.actionDialogOpened}
          closeDialogHandler={(ignore_refetch) => {
            this.setState({
              singleSelectRequest: null
            });
            this.handleCashlessActionDialogCloseClicked(ignore_refetch);
          }}
          title={this.state.actionDialogTitle}
          innerActionConent={this.state.actionDialogContent}
          isRejection={this.state.isActionRejection}
          requestids={
            this.state.singleSelectRequest
              ? [this.state.singleSelectRequest]
              : this.state.selectedRequestIdList
          }
        />
      </>
    );
  }
}

export default CashlessMain;
